/**
 * Measure data, including the time signature and tempo.
 */
export default class Measure {
  beats: number; //the 3 in 3/4
  beatType: number; //the 4 in 3/4
  tempo: number; //e.g. 120 bpm
  durationSeconds: number; //number of seconds the measure lasts.
  constructor({beats, beatType, tempo, durationSeconds,}: Measure) {
    Object.assign(this, {beats, beatType, tempo, durationSeconds});
  }
}